/**
 * PipedriveAPIV1Lib
 *
 * This file was automatically generated by APIMATIC v2.0 ( https://apimatic.io ).
 */

'use strict';

const ItemsEnum = {

    /**
     * TODO: Write general description for this element
     */
    ACTIVITY: 'activity',

    /**
     * TODO: Write general description for this element
     */
    ACTIVITY_TYPE: 'activityType',

    /**
     * TODO: Write general description for this element
     */
    DEAL: 'deal',

    /**
     * TODO: Write general description for this element
     */
    DELETE_LOG: 'delete_log',

    /**
     * TODO: Write general description for this element
     */
    FILE: 'file',

    /**
     * TODO: Write general description for this element
     */
    FILTER: 'filter',

    /**
     * TODO: Write general description for this element
     */
    NOTE: 'note',

    /**
     * TODO: Write general description for this element
     */
    PERSON: 'person',

    /**
     * TODO: Write general description for this element
     */
    ORGANIZATION: 'organization',

    /**
     * TODO: Write general description for this element
     */
    PIPELINE: 'pipeline',

    /**
     * TODO: Write general description for this element
     */
    PRODUCT: 'product',

    /**
     * TODO: Write general description for this element
     */
    STAGE: 'stage',

    /**
     * TODO: Write general description for this element
     */
    USER: 'user',

};

module.exports = ItemsEnum;
